import React, { useEffect } from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import Filter from './Filter';
import constants from 'constants/index';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { Tooltip } from 'primereact/tooltip';
import { useNavbarContext } from 'context/NavbarContext';

export default function Header(props) {
  const { setShowLeadSettings } = props;
  const userDetails = useUserDetailsContext();
  const history = useHistory();
  const { notificationData } = useNavbarContext();

  useEffect(() => {
    notificationData?.loadNotificationCount();
  }, []);

  return (
    <React.Fragment>
      <GlobalLoader />
      <div className="d-flex justify-content-between align-items-center ">
        <h1 className="title mb-0">Leads</h1>
      </div>
      <div className="d-flex align-items-center mb-3 justify-content-between flex-wrap">
        <Filter />
        <div className="d-flex align-items-center my-2">
          <Button
            icon="icon-Setting cursor-pointer F-size22"
            className="p-button-primary button outline ms-2 btn-square-40"
            onClick={() => setShowLeadSettings(true)}
          >
            <Tooltip content="Lead Display Settings" position="bottom" target="#lead-gear" style={{ bottom: 0 }} showDelay={500} />
          </Button>
          <div className="">
            <Button
              style={{ overflow: 'visible', color: 'white' }}
              label="Online Leads"
              className="p-button-primary button outline ms-2"
              onClick={() => history.push('/leads/online')}
            >
              {Number(notificationData?.notificationCount?.online_lead_count) > 0 && (
                <p className="indicator-online-lead">{notificationData?.notificationCount?.online_lead_count}</p>
              )}
            </Button>
            {userDetails.getPermission('leads') === constants.permissions.WRITE && (
              <Button
                label="Add New Lead"
                icon="pi pi-plus"
                className="button p-button p-component p-button p-button-primary ms-2"
                onClick={() => history.push('/leads/new')}
              />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
